module.exports = __webpack_public_path__ + "media/images/ui__infoOk-3d91d9778db97793484ac057adf5a19c.png";